module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-04-ed9c3c6c218ac812cc99d5d13dc75520.webp";